// WHAT CAN BE CHANGED?
// You can change the display name of the admin below
// It's also possible to change the background colour, text colour and font

<template>
  <div id="chatbox">
    <!-- Standard Admin Message -->
    <div class="chatbox__message adminMessage">
      <h2>{{ adminDisplayName }}</h2>
      <p class="chatbox__message__text">
        Heb je iets leuks wat je met de studio wilt delen? Stuur het ons door en
        wie weet hoor je het terug in de uitzending!
      </p>
    </div>
    <!-- Messages from FireBase -->
    <div
      v-for="singleMessage in chatboxMessages"
      :key="singleMessage"
      :time="singleMessage.time"
      v-bind:class="{ adminMessage: singleMessage.fromAdmin }"
      class="chatbox__message"
    >
      <h2 v-if="singleMessage.fromAdmin">{{ adminDisplayName }}</h2>
      <h2 v-else>Jij</h2>
      <div v-if="singleMessage.isFile">
        <FileRewatch :fileURL="singleMessage.fileURL" />
      </div>
      <p v-if="singleMessage.isFile" class="chatbox__message__text">
        {{ singleMessage.fileMessage }}
      </p>
      <p v-if="!singleMessage.isFile" class="chatbox__message__text">
        {{ singleMessage.message }}
      </p>
      <p class="chatbox__message__time">{{ singleMessage.time }}</p>
    </div>
  </div>
</template>

<script>
import FileRewatch from "@/components/FileRewatch.vue";

import "firebase/firestore";
import "firebase/firebase-storage";
import db from "@/firebase/firebaseInit";

export default {
  name: "Chatbox",
  components: {
    FileRewatch,
  },
  props: {
    userData: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.initUserInputInChat();
  },
  methods: {
    initUserInputInChat() {
      db.firestore()
        .collection("messages")
        .orderBy("time")
        .onSnapshot((snapshot) => {
          this.chatboxMessages = [];
          snapshot.forEach((doc) => {
            if (doc.data().uid == this.userData[0].uid) {
              this.chatboxMessages.push({
                message: doc.data().message,
                isFile: doc.data().isFile,
                time: doc.data().time,
                fileMessage: doc.data().fileMessage,
                fileURL: doc.data().fileURL,
                fromAdmin: doc.data().fromAdmin,
              });
            }
          });
          sessionStorage.setItem("data", JSON.stringify(this.chatboxMessages));
        });
    },
  },
  data() {
    return {
      adminDisplayName: "RTV Parkstad",
      chatboxMessages: [],
    };
  },
};
</script>

<style lang="scss" scoped>
$chatbox__background--colour: #ff6600;
$chatbox__text--colour: #ff6600;
$chatbox__text--font: "Lato";

#chatbox {
  font-family: $chatbox__text--font;
  max-width: 768px;
  box-sizing: border-box;
  width: calc(100vw - 32px);
  margin-bottom: 58px;
  display: flex;
  flex-direction: column;

  .chatbox__message {
    align-self: flex-end;
    background-color: $chatbox__background--colour;
    color: white;
    margin-left: 40px;
    max-width: 400px;
    padding: 8px;
    border-radius: 5px;
    box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);
    margin-bottom: 20px;

    h2 {
      font-size: 14px;
    }
    .chatbox__message__text {
      font-size: 14px;
    }
    .chatbox__message__file-text {
      border: 1px solid white;
      padding: 6px 12px 8px 6px;
      border-radius: 999px;
      margin-top: 6px;
      margin-bottom: 6px;
      background-color: #fcfcfc;
      color: #ff6600;
      font-weight: bold;
      font-size: 14px;
    }

    .chatbox__message__time {
      opacity: 0.7;
      font-size: 12px;
      margin-top: 4px;
      float: right;
    }
  }

  .adminMessage {
    align-self: flex-start;
    background-color: #f3f3f3 !important;
    color: black;
    margin-right: 40px;
    margin-left: 0px;
    h2 {
      color: $chatbox__text--colour;
    }
    .chatbox__message__time {
      float: left;
    }
  }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
  #chatbox {
  }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
  #chatbox {
  }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px) {
  #chatbox {
  }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px) {
  #chatbox {
  }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px) {
  #chatbox {
  }
}
</style>